import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const permissionGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // First check if the user is logged in
  if (!authService.isLoggedIn()) {
    return router.parseUrl('/login');
  }

  // Then check if the user has the access_backoffice permission (mapped from BACKOFFICE_ACCESS role)
  if (!authService.hasPermission('access_backoffice')) {
    console.log('Brak uprawnień access_backoffice');
    return router.parseUrl('/login');
  }

    // Then check if the user has the BACKOFFICE_PGW permission (mapped from BACKOFFICE_ACCESS role)
    if (!authService.hasPermission('BACKOFFICE_PGW')) {
        console.log('Brak uprawnień BACKOFFICE_PGW');
        return router.parseUrl('/login');
    }

  // User has the required permission
  console.log('dostep dozwolony');
  return true;
};
